export default __webpack_public_path__ + "static/media/chevron-left-colored.d7951a8a.svg";